import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      _defineProperty(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

import React, { useState, useEffect, useRef } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import config from "../../config"; // Components

import Button from "../Button";
import SocialSharing from "../SocialSharing";
import Advertising from "../Advertising";
import { withUserMenu } from "../UserMenu";
import Navigation from "./Navigation";
import Map from "./Map";
import "./Masterplan.scss";

var NB_SLUG = config.get("api.neighbourhood"),
    parseItems = function parseItems(a) {
  return function (b) {
    var c = b.name,
        d = b.coords,
        e = b.landforsale,
        f = b.lots,
        g = _objectWithoutProperties(b, ["name", "coords", "landforsale", "lots"]);

    b.slug = b.slug ? b.slug.toString() : "";
    var h = a.neighbourhood,
        i = a.release,
        j = i && !NB_SLUG ? "".concat(h.slug, "/").concat(i.slug) : i && NB_SLUG ? i.slug : h && !NB_SLUG ? h.slug : "";
    return _objectSpread({
      name: c,
      slug: b.slug,
      coords: d,
      href: !e && !f ? config.routes.get("landforsale.masterplan", j, "lot", b.slug) : config.routes.get("landforsale.masterplan", j, b.slug),
      releases: e,
      lots: f
    }, g);
  };
};

export var MasterplanComponent = function MasterplanComponent(a) {
  var b,
      c = a.userMenu,
      d = a.className,
      e = a.navigation,
      f = a.neighbourhoods,
      g = f.project,
      h = f.assetpath,
      i = f.data,
      j = a.selectedNeighbourhood,
      k = a.selectedRelease,
      l = a.selectedLot,
      m = a.title,
      n = a.getActiveImage,
      o = a.showFilters,
      p = a.noAdvancedSearch,
      q = a.isResultPage,
      r = _objectWithoutProperties(a, ["userMenu", "className", "navigation", "neighbourhoods", "selectedNeighbourhood", "selectedRelease", "selectedLot", "title", "getActiveImage", "showFilters", "noAdvancedSearch", "isResultPage"]),
      s = useRef(),
      t = useState(null),
      u = _slicedToArray(t, 2),
      v = u[0],
      w = u[1],
      x = function x(a) {
    v !== a && w(a);
  };

  i = i.filter(function (a) {
    return 0 < a.landforsale.length;
  });
  var y = {},
      z = [],
      A = null,
      B = j ? i.find(function (a) {
    var b = a.slug;
    return b === j;
  }) : null,
      C = B && k ? B.landforsale.find(function (a) {
    var b = a.slug;
    return b === k;
  }) : B && !k ? B.landforsale.find(function (a) {
    var b = a.lots.find(function (a) {
      var b = a.slug;
      return b === l;
    });
    return !!b && (A = b, !0);
  }) : null;
  A = A ? A : C && l ? C.lots.find(function (a) {
    var b = a.slug;
    return b === l;
  }) : null;
  var D = parseItems({
    neighbourhood: B,
    release: C
  });
  A ? (!m && (m = A.name), y = {
    src: A.image.url,
    width: A.image.width,
    height: A.image.height
  }) : C ? (!m && (m = C.name), z = C.lots.map(D), y = {
    src: C.image.url,
    width: C.image.width,
    height: C.image.height
  }) : B ? (!m && (m = B.name), z = B.landforsale.map(D) // @NOTE this is a fix to not hide published (disabled on the backend side)
  // releases on the Masterplan
  .filter(function (a) {
    return !a.published;
  }), y = {
    src: B.image.url,
    width: B.image.width,
    height: B.image.height
  }) : (!m && (m = "Masterplan"), z = i.map(D), y = {
    src: g.image.url,
    width: g.image.width,
    height: g.image.height
  }), useEffect(function () {
    s.current || ("function" == typeof n && n(y), s.current = !0);
  }, [n, y]);

  var E = _slicedToArray(c, 2),
      F = E[1];

  useEffect(function () {
    A && F.addRecentlyViewed(A);
  }, [F, A]);
  var G = config.downloads.get("masterplan"),
      H = config.downloads.get("design_guidelines"),
      I = config.downloads.get("due_diligence"),
      J = G ? G : B ? B.masterplan_flyer : g.masterplan_flyer,
      K = H ? H : B ? B.design_guidelines_flyer : g.design_guidelines_flyer,
      L = I ? I : B ? B.duediligence_flyer : g.duediligence_flyer;
  return !B && j ? "Neighbourhood doesn't exists" : !C && k ? "Release doesn't exists" : !A && l ? "Lot doesn't exists" : /*#__PURE__*/React.createElement("section", {
    className: classnames(d, "lfs", {
      isLot: A
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "ta-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ta-row"
  }, /*#__PURE__*/React.createElement(SocialSharing, null)), /*#__PURE__*/React.createElement("div", {
    className: "ta-row"
  }, e && /*#__PURE__*/React.createElement(Navigation, {
    title: m,
    menu: z,
    onHover: x,
    hovered: v,
    release: C,
    lot: A,
    assetPath: h,
    showFilters: o,
    noAdvancedSearch: p,
    isResultPage: q
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames("lfs--map", (b = {
      "no-nav": !e
    }, _defineProperty(b, "ta-".concat(k), C && C.slug), _defineProperty(b, "ta-neighbourhood--".concat(j), B && B.slug), b))
  }, /*#__PURE__*/React.createElement(Map, {
    key: m,
    image: y,
    polygons: z,
    onHover: x,
    hovered: v,
    neighbourhood: B,
    release: C,
    lot: A
  }), J || K || L ? /*#__PURE__*/React.createElement("div", {
    className: "lfs--downloads"
  }, /*#__PURE__*/React.createElement("h4", null, "Downloads"), J && /*#__PURE__*/React.createElement(Button, {
    size: "small",
    href: J,
    icon: "download",
    color: "secondary",
    external: !0
  }, "Masterplan"), K && /*#__PURE__*/React.createElement(Button, {
    size: "small",
    href: K,
    icon: "download",
    color: "secondary",
    external: !0
  }, "Design guidelines"), L && /*#__PURE__*/React.createElement(Button, {
    size: "small",
    href: L,
    icon: "download",
    color: "secondary",
    external: !0
  }, "Due Diligence")) : null, A ? /*#__PURE__*/React.createElement(Advertising, {
    className: "ad",
    query: [{
      type: "land",
      value: "".concat(A.release_slug, "/").concat(A.slug)
    }, {
      type: "release",
      value: A.release_slug
    }, {
      type: "neighbourhood",
      value: A.neighbourhood_slug
    }],
    height: 200
  }) : null))));
};
export var Masterplan = withUserMenu(MasterplanComponent);
Masterplan.propTypes = {
  navigation: PropTypes.bool
};
export default Masterplan;